import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";

export const encryptUrl = async (data) => {
  const req = `${BASE_URL}/workflow/encryptUrl`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ _id: data }),
  };
  try {
    if(data){
    const result = await apiRequest(req, options,true);
    if(result.status == "failed"){
      window.location.href = "/unified/error"
    }
    return result.encrypt;
  }
  } catch (error) {
    window.location.href = "/unified/error"
    throw error;
  }
};

export const encryptURLConditionalRedirection = async (data) => {
  const req = `${BASE_URL}/workflow/encryptURLConditionalRedirection`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ _id: data }),
  };
  try {
    const result = await apiRequest(req, options,true);
    if(result.status == "failed"){
      window.location.href = "/unified/error"
    }
    return result.encrypt;
  } catch (error) {
    window.location.href = "/unified/error"
    throw error;
  }
};

export const decryptUrl = createAsyncThunk(
  "decryptUrl",
  async ({ key, value }) => {
    // console.log(key,value);
    const req = `${BASE_URL}/workflow/decryptUrl`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ _id: value }),
    };
    try {
      const result = await apiRequest(req, options,true);
      if(result.status == "failed"){
        window.location.href = "/unified/error"
      }
      return { key: key, value: result.decrypt };
    } catch (error) {
      window.location.href = "/unified/error"
      throw error;
    }
  }
);

export const decryptURLConditionalRedirection = createAsyncThunk(
  "decryptUrl",
  async ({ key, value }) => {
    // console.log(key,value);
    const req = `${BASE_URL}/workflow/decryptURLConditionalRedirection`;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ _id: value }),
    };
    try {
      const result = await apiRequest(req, options,true);
      if(result.status == "failure"){
        window.location.href = "/unified/error"
      }
      return { key: key, value: result.decrypt };
    } catch (error) {
      window.location.href = "/unified/error"
      throw error;
    }
  }
);

export const encryptURLParams = async (body) => {
  const req = `${BASE_URL}/workflow/encryptURLParams`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };
  try {
    const result = await apiRequest(req, options,true);
    return result.data;
  } catch (error) {
    console.error(error);
  }
};

export const getURLParams = createAsyncThunk("getURLParams", async (body) => {
  const req = `${BASE_URL}/workflow/getURLParams`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  };
  try {
    const result = await apiRequest(req, options,true);
    return result?.data;
  } catch (error) {
    console.log(error);
  }
});
